import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import StudentEngagementGauge from './StudentEngagementGauge';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';
import { StudentEngagementListService } from '../../services/CustomerSuccessKpiListService';

class StudentEngagementCompanyGaugeContainer extends React.Component {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    StudentEngagementListService.load();
  }

  render() {
    const data = toJS(StudentEngagementListService.getByCompanyId(this.props.companyId));
    return (
      <StudentEngagementGauge
        loading={
          StudentEngagementListService.fetchCurrent.fetching || StudentEngagementListService.fetchPrevious.fetching
        }
        currentValue={data.current}
        previousValue={data.previous}
        onClickHistory={() => CustomerSuccessHistoryService.openDialog('STUDENT_ENGAGEMENT', this.props.companyId)}
        formatter={StudentEngagementListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentEngagementCompanyGaugeContainer);
